import Vue from "vue";
import VueResource from "vue-router";

Vue.use(VueResource);

const iOrder = {
  async fetchUsersOrders({ userEmail, identifier, config }) {
    const data = {
      method: "getMyOrders",
      userDeviceIdentifier: identifier,
      userEmailAddress: userEmail,
      version: "1.0.0",
      platform: "iPhone OS",
      bundleIdentifier: "x",
    };
    const requestHeaders = await Object.assign({}, config.headers);
    const res = await Vue.http.post(
      config.iOrderUrl,
      "request=" + JSON.stringify({ request: data }),
      {
        headers: requestHeaders,
      }
    );
    return res;
  },
  checkBasket(
    {
      siteId,
      salesAreaId,
      basketLines,
      voucherLines,
      serviceId,
      user,
      config,
      identifier,
    },
    callback
  ) {
    const data = {
      method: "checkBasket",
      siteId,
      venueId: siteId,
      salesAreaId,
      serviceId,
      lines: basketLines,
      voucherLines,
      userDeviceIdentifier: identifier,
    };
    const requestHeaders = Object.assign({}, config.headers);
    Vue.http
      .post(config.iOrderUrl, "request=" + JSON.stringify({ request: data }), {
        headers: requestHeaders,
      })
      .then((res) => {
        if (res.data.response === "error") {
          return callback(res.data);
        }
        callback(null, res.data);
      })
      .catch(callback);
  },
  checkVoucher(
    { siteId, salesAreaId, voucherCode, identifier, config },
    callback
  ) {
    const data = {
      method: "checkVoucher",
      siteId,
      salesAreaId,
      userDeviceIdentifier: identifier,
      voucherCode,
    };
    const requestHeaders = Object.assign({}, config.headers);
    Vue.http
      .post(config.iOrderUrl, "request=" + JSON.stringify({ request: data }), {
        headers: requestHeaders,
      })
      .then((res) => {
        if (res.data.response === "error") {
          return callback(res.data);
        }
        callback(null, res.data);
      })
      .catch(callback);
  },
  makeBraintreePayment(
    {
      nonce,
      paymentMethod,
      description,
      deviceData,
      table,
      basketId,
      siteId,
      salesAreaId,
      user,
      config,
    },
    callback
  ) {
    const data = {
      method: "makeBraintreePayment",
      platform: "web",
      userEmailAddress: user.email,
      customerName: user.name,
      phoneNumber: user.phone,
      siteId,
      salesAreaId,
      basketId,
      table,
      nonce,
      deviceData,
      paymentMethod,
    };
    const requestHeaders = Object.assign({}, config.headers);
    Vue.http
      .post(config.iOrderUrl, "request=" + JSON.stringify({ request: data }), {
        headers: requestHeaders,
      })
      .then((res) => {
        if (res.data.response === "error") {
          return callback(res.data);
        }
        callback(null, res.data);
      })
      .catch(callback);
  },
  getTables({ siteId, salesAreaId, config }, callback) {
    const data = {
      method: "getTables",
      siteId,
      salesAreaId,
    };
    Vue.http
      .post(config.iOrderUrl, "request=" + JSON.stringify({ request: data }), {
        headers: config.headers,
      })
      .then((res) => {
        if (res.data.response === "error") {
          return callback(res.data);
        }
        callback(null, res.data.tables);
      })
      .catch(callback);
  },
  getVenue({ siteId, config }, callback) {
    const data = {
      method: "venues",
      siteId,
    };
    Vue.http
      .post(config.iOrderUrl, "request=" + JSON.stringify({ request: data }), {
        headers: config.headers,
      })
      .then((res) => {
        if (res.data.response === "error") {
          return callback(res.data);
        }
        callback(null, res.data);
      })
      .catch(callback);
  },
  getMenus({ siteId, salesAreaId, config }, callback) {
    const data = {
      method: "getMenus",
      siteId,
      salesAreaId,
    };
    Vue.http
      .post(config.iOrderUrl, "request=" + JSON.stringify({ request: data }), {
        headers: config.headers,
      })
      .then((res) => {
        if (res.data.response === "error") {
          return callback(res.data);
        }
        callback(null, res.data);
      })
      .catch(callback);
  },
  getMenuPages({ siteId, salesAreaId, menuId, config }, callback) {
    const data = {
      method: "getmenupages",
      siteId,
      salesAreaId,
      menuId,
    };
    Vue.http
      .post(config.iOrderUrl, "request=" + JSON.stringify({ request: data }), {
        headers: config.headers,
      })
      .then((res) => {
        if (res.data.response === "error") {
          return callback(res.data);
        }
        callback(null, res.data);
      })
      .catch(callback);
  },
  login({ email, password, config }, callback) {
    let data = {
      method: "postLoginEmail",
      user: {
        email,
        password,
      },
    };
    Vue.http
      .post(config.iOrderUrl, "request=" + JSON.stringify({ request: data }), {
        headers: config.headers,
      })
      .then((res) => {
        if (res.data.response === "error") {
          return callback(res.data);
        }
        callback(null, res.data);
      })
      .catch(callback);
  },
  register({ email, password, firstName, config }, callback) {
    let data = {
      method: "postRegisterUser",
      user: {
        email,
        password,
        firstName,
      },
    };
    Vue.http
      .post(config.iOrderUrl, "request=" + JSON.stringify({ request: data }), {
        headers: config.headers,
      })
      .then((res) => {
        if (res.data.response === "error") {
          return callback(res.data);
        }
        callback(null, res.data);
      })
      .catch(callback);
  },
  resetPassword({ email, config }, callback) {
    let data = {
      method: "resetPassword",
      email,
    };
    Vue.http
      .post(config.iOrderUrl, "request=" + JSON.stringify({ request: data }), {
        headers: config.headers,
      })
      .then((res) => {
        if (res.data.response === "error") {
          return callback(res.data);
        }
        callback(null, res.data);
      })
      .catch(callback);
  },
};

Vue.prototype.$iOrder = iOrder;

export default iOrder;
